import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllChecklistServicoLiberacaoUseCase } from "../../../presentation/useCases/read/get_all_checklist_servico_liberacao_use_case";
import { ChecklistServicoLiberacao } from "../../models/checklist_servico_liberacao";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetAllChecklistServicoLiberacaoUseCase
 */

export class GetAllChecklistServicoLiberacaoUseCase
  extends BasePaginatedUseCase<ChecklistServicoLiberacao>
  implements IGetAllChecklistServicoLiberacaoUseCase {

  constructor(private readonly repository: IObrasRepository) {
    super();
  }

  async execute(
    idChecklistServico: number,
    descricao: string | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (idChecklistServico === undefined) throw new Error('Id de obra invalido!');

    const response = await this.repository
      .getAllChecklistServicoLiberacao(
        idChecklistServico,
        descricao,
        page,
        rowsPerPage,
      );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
